import { render, staticRenderFns } from "./PopupServerError.vue?vue&type=template&id=7e151dc0&scoped=true"
import script from "./PopupServerError.vue?vue&type=script&lang=js"
export * from "./PopupServerError.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e151dc0",
  null
  
)

export default component.exports